/**
 * Shared "payment received — processing" banner for the RECONCILIATION_REQUIRED
 * outcome (backlog M10). Square charged the card, but process-payment's own
 * record-write or membership/registration update failed afterwards.
 *
 * Factored out rather than copy-pasted across MemberDashboard, MemberCheckInForm,
 * NonMemberRegistrationForm and CompetitionsList: the copy is money-sensitive
 * (it tells a real person not to pay again) and should have exactly one place
 * to get right and one place to update if the wording ever needs to change.
 */
interface PaymentReconciliationNoticeProps {
  paymentReference: string;
}

export default function PaymentReconciliationNotice({
  paymentReference,
}: PaymentReconciliationNoticeProps) {
  return (
    <div className="bg-amber-50 border border-amber-300 rounded-lg p-4 mb-4 text-left">
      <p className="font-medium text-amber-900">⚠️ Payment received — processing</p>
      <p className="text-sm text-amber-800 mt-1">
        Your card was charged successfully, but we hit a snag recording it.{' '}
        <strong>Please do not pay again.</strong> Your reference is{' '}
        <span className="font-mono">{paymentReference}</span> — quote this if you contact the
        club at{' '}
        <a href="mailto:fishing@tumbyfc.com" className="underline">
          fishing@tumbyfc.com
        </a>
        . We'll confirm this manually.
      </p>
    </div>
  );
}
